export default __webpack_public_path__ + "media/zurb/img/legacy/chop/4-341b167f2e095e5157df88fbfe4bd486.png";